import { Style } from 'ol/style';
import { CustomMap } from '@vendor/libs/maps/maps';
// @todo refactor
export const checkVisibility = (feature, visibilityName) => {
    if (!visibilityName) {
        return true;
    }
    // @ts-ignore
    if (typeof feature._mapId != 'undefined') {
        // @ts-ignore
        const customMap = CustomMap.getMap(feature._mapId);
        if (customMap) {
            const interfaceElement = customMap.interfaceElements['layers-and-base'] ?? null;
            if (interfaceElement && !interfaceElement.isVisible(visibilityName)) {
                return false;
            }
        }
    }
    return true;
};
export const baseStyle = function (feature, resolution, style) {
    // hide if not visible
    if (!checkVisibility(feature, feature.get('name'))) {
        return new Style({});
    }
    return style(feature, resolution);
};
